import React, { useEffect, useRef } from 'react';
import { Pagination, usePagination } from 'react-instantsearch';

const CustomPagination = () => {
    const { currentRefinement } = usePagination();
    const previousPage = useRef(currentRefinement);

    useEffect(() => {
        if (previousPage.current !== currentRefinement) {
            setTimeout(() => {
                const container = document.getElementById('search-overlay');
                if (container) {
                    container.scrollTo({ top: 0, behavior: 'smooth' });
                }
            }, 100);

            previousPage.current = currentRefinement;
        }
    }, [currentRefinement]);

    return (
        <div className="ais-Pagination search-pagination">
            <Pagination />
        </div>
    );
};

export default CustomPagination;